import React from "react";
import { Card, Row, Container, Col } from "react-bootstrap";
import ResumeCard from "../cards/resumeCard";
import MainCard  from "../cards/inventoryMainCard";
import "../../assets/styles/inventory.scss";
import { Navigation, UpdateBar } from "../header/header";

class Inventory extends React.Component {
  constructor(props) {
    super(props);
    this.user = props.user;
    this.state = {
      data: {},
      productSales: {},
      selections: {},
      update: false
    };
    this.d = "";
    this.ws = this.props.ws;
    this.handler = this.handler.bind(this);
  }

  handler() {
    this.setState({
      update: true
    });
  }
  render() {
    return (
      <div>
      <Navigation title={this.props.title} handler={this.handler} ws={this.ws} />
      {this.state.update ? (
        <div>
          <UpdateBar />
          <Container className="mt-4" fluid={true}>
            <ResumeCard
              className="inventory"
              selections={this.state.selections}
              user={this.user}
              customClass="inventory"
              ws={this.ws}
              update={this.state.someVar}
            />
            <MainCard ws={this.ws} />
          </Container>
        </div>
      ) : (
        <h1>esto</h1>
      )}
    </div>
    );
  }

  InventoryCard = () => {
    return (
      <Row>
        <Card className="col-12">
          <Card.Body>
            <Card.Title>
              <div>
                <div className="top-left-icon sale-icon"></div>
                <span className="ml-5 pl-4">Inventario</span>
              </div>
            </Card.Title>
            <Row className="mt-sm-5">
              <Col md={6}>Productos</Col>
              <Col md={6}>Unidades de Negocio / estatus Inventario</Col>
            </Row>
          </Card.Body>
        </Card>
      </Row>
    );
  };
}

export default Inventory;
